import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ConfigService } from '../configHelper';

@Injectable({
   providedIn: 'root'
})
export class PackageDataService {

   constructor(private httpClient: HttpClient, private configService: ConfigService) {
   }

   public getList(start, count, sortBy, sortDirection, gridFilters, filters) {
     let url: string = `${this.configService.getConfig().apiURL}v1/Internal/Package/GetList?start=${start}&length=${count}&sortBy=${sortBy}&sortDirection=${sortDirection}&gridFilters=${JSON.stringify(gridFilters)}&filters=${JSON.stringify(filters)}`;
      return this.httpClient.get(url);
  }

  public getListWithExceptions(start, count, sortBy, sortDirection, filters) {
    let url: string = `${this.configService.getConfig().apiURL}v1/Internal/Package/GetListWithExceptions?start=${start}&length=${count}&sortBy=${sortBy}&sortDirection=${sortDirection}&filters=${JSON.stringify(filters)}`;
    return this.httpClient.get(url);
  }

   public getListForClient(clientId) {
      let url: string = `${this.configService.getConfig().apiURL}v1/Internal/Package/GetListForClient?clientId=${clientId}`;
      return this.httpClient.get(url);
   }

   public getFilters() {
      let url: string = `${this.configService.getConfig().apiURL}v1/Internal/Package/GetFilters`;
      return this.httpClient.get(url);
   }

   public getPackage(id, withimage = false) {
      var url: string;
      if (withimage) {
        url = `${this.configService.getConfig().apiURL}v1/Internal/Package/GetPackageWithImage?id=${id}`;
      } else {
         url = `${this.configService.getConfig().apiURL}v1/Internal/Package/GetPackage?id=${id}`;
      }
      return this.httpClient.get(url);
   }

   public getPackageByInternalId(internalId, withimage = false) {
      var url: string;
      if (withimage) {
         url = `${this.configService.getConfig().apiURL}v1/Internal/Package/GetPackageByInternalIdWithImage?internalId=${internalId}`;
      } else {
         url = `${this.configService.getConfig().apiURL}v1/Internal/Package/GetPackageByInternalId?internalId=${internalId}`;
      }
      return this.httpClient.get(url);
   }

   public getPackageByTrackingId(trackingId) {
      var url: string;
      url = `${this.configService.getConfig().apiURL}v1/Internal/Package/GetPackageByTrackingId?trackingId=${trackingId}`;
      return this.httpClient.get(url);
  }

  public getPackageForIntake(trackingId) {
    var url: string;
    url = `${this.configService.getConfig().apiURL}v1/Internal/Package/GetPackageForIntake?trackingId=${trackingId}`;
    return this.httpClient.get(url);
  }

   public completePackage(id) {
      let url: string = `${this.configService.getConfig().apiURL}v1/Internal/Package/CompletePackage?id=${id}`;
      return this.httpClient.get(url);
   }

  public reopenPackage(id) {
    let url: string = `${this.configService.getConfig().apiURL}v1/Internal/Package/ReopenPackage?id=${id}`;
    return this.httpClient.get(url);
  }

   public openPackage(id) {
      let url: string = `${this.configService.getConfig().apiURL}v1/Internal/Package/OpenPackage?id=${id}`;
      return this.httpClient.get(url);
   }

   public getEmptyModel() {
      let url: string = `${this.configService.getConfig().apiURL}v1/Internal/Package/GetEmptyPackage`;
      return this.httpClient.get(url);
   }

   public getShipmentTypes() {
      let url: string = `${this.configService.getConfig().apiURL}v1/Internal/Package/GetShipmentTypes`;
      return this.httpClient.get(url);
   }

   public savePackage(pkg) {
      if (pkg.Id === 0) {
         let url: string = `${this.configService.getConfig().apiURL}v1/Internal/Package/Package`;
         return this.httpClient.post(url, pkg);
      } else {
         let url: string = `${this.configService.getConfig().apiURL}v1/Internal/Package/Package?id=${pkg.Id}`;
         return this.httpClient.put(url, pkg);
      }
  }

  public updatePackageResolveTeamAssignedTo(pkg) {
    let url: string = `${this.configService.getConfig().apiURL}v1/Internal/Package/UpdatePackageResolveTeamAssignedTo`;
    return this.httpClient.post(url, pkg);
  }

  public hasTrackingNumberBeenReceived(trackingNumber) {
    let url: string = `${this.configService.getConfig().apiURL}v1/Internal/Package/HasTrackingNumberBeenReceived?trackingNumber=${trackingNumber}`;
    return this.httpClient.get(url);
   }

   public getPackagesToCheck() {
      let url: string = `${this.configService.getConfig().apiURL}v1/Internal/Package/GetPackagesToCheck`;
      return this.httpClient.get(url);
   }

   public checkPackageRequisitions(id) {
      let url: string = `${this.configService.getConfig().apiURL}v1/Internal/Package/CheckPackageRequisitions?id=${id}`;
      return this.httpClient.get(url);
   }


}
